<main>
  <app-modal [showModal]='initModal' *ngIf="learn">
    <div #accessModal class="model-cover terms">
      <div class="model-box" (keydown)="handleKeydown($event)">
        <div class="modal-header">
          <h2 *ngIf="user && permissionLevelMessage">{{learn.authModalHeader.value}}</h2>
          <div class="corner-button">
            <button class="close" aria-label="Close" (click)="closeModal()">x</button>
          </div>
        </div>

        <div class="modal-body">
          <p *ngIf="user && permissionLevelMessage">{{learn.authModalHeader.value2}}</p>
          <p *ngIf="user && permissionLevelMessage">{{learn.toContinue.value}}</p>
          <p [innerHTML]="permissionLevelMessage"></p>
        </div>

        <div class="text-right modal-footer">
          <div class="button-group">
            <button (click)="closeModal()" class="btn btn-secondary ok-btn" type="button" name="action"
              aria-label="OK.">OK</button>
          </div>
        </div>
      </div>

    </div>
  </app-modal>
  <section *ngIf="learn" aria-labelledby="bannerHeadingSection">
    <div class="banner-section-learn">
      <figure>
        <img class="lg-hide" src="assets/img/learnmobile1.jpg" alt="banner" />
        <img class="sm-hide" src="assets/img/learn.jpg" alt="banner" />
      </figure>
      <div class="banner-caption-learn">
        <div class="main-wrapper">
          <div class="row">
            <div class="col-sm-12 col-md-5">
              <h1 id="bannerHeadingSection">{{learn.displayName.value}}</h1>
              <p>{{learn.message.value}}</p>
              <p>{{learn.bodyText.value}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-5">
              <div class="btn-eligibility" *ngIf="!user">
                <button (click)="checkEligibility()" class="btn btn-secondary"
                  attr.aria-label="{{learn.checkEligibility.accessibilityText}}">{{learn.checkEligibility.value}}</button>
              </div>
              <!-- <div class="learn-more" [ngClass]="{'align': !user}">{{learn.overview.value}}
                <a href="javascript:void(0)" (click)="openOverviewModal()" title="Opens a Video about the Device Management Program">{{learn.overview.linkValue}}</a>
              </div> -->
              <div class="letsGetStarted" *ngIf="user">
                <a href="javascript:void(0)" (click)="getStarted()">{{learn.letsGetStarted.value}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="showOverviewModal">
          <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass">
                <app-gvp-video (modalOutput)="closeOverviewModal()" [triggerElement]='eventEmit' [videoId]="videoId">
                </app-gvp-video>  
          </app-modal>
    </div> -->
    </div>
    <!-- <div class="main"> -->
    <div *ngIf="user && permissionLevelMessage" class="msg-content">
      <span>{{permissionLevelMessage}}</span>
    </div>
    <!-- <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="Close"></div> -->
    <!-- </div> -->

  </section>
  <!-- TAB section start here-->
  <section aria-label="Tabs Section">
    <!-- <div class="main"> -->
    <app-tabs [tabs]="tabDetails" [ariaLabel]="learn.displayName.value" *ngIf='showTab'>
      <app-tab class="app-tab-learn" *ngFor='let td of tabDetails; let i = $index' [option]="td">
        <div [innerHTML]='td.description'></div>
      </app-tab>
    </app-tabs>
    <!-- </div> -->
  </section>
</main>